const workflowBaseUrl = () => import.meta.env.VITE_IRONCLAD_WORKFLOW_URL;

export function isWorkflowConfigured(): boolean {
  return !!workflowBaseUrl();
}

// Builds the Ironclad public-launch URL. Params go in the fragment, encoded
// manually so spaces are %20 (not the + URLSearchParams emits) and bracketed
// keys stay %5B/%5D, which the workflow parses into nested objects.
export function buildWorkflowUrl(signerId: string, prefill: Record<string, string> = {}): string {
  const url = new URL(workflowBaseUrl());
  const parts: string[] = [];
  if (signerId) parts.push(`signer=${encodeURIComponent(signerId)}`);
  for (const [key, value] of Object.entries(prefill)) {
    if (value) parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  }
  url.hash = "";
  return parts.length ? `${url.toString()}#${parts.join("&")}` : url.toString();
}
